import 'babel-polyfill'
import 'cookieconsent'
import './bootstrap.scss'

import Typewriter from './js/Typewriter'
import NewMobileNav from './js/NewMobileNav'
import DynamicNav from './js/DynamicNav'
import Register from './js/Register'
import Recovery from './js/Recovery'

import {
	Carousel,
	Accordion,
	Address,
	Orders,
	ShoppingcartAddressSection,
	ShoppingcartPopup,
	ShoppingcartPopupButton,
	ShoppingcartProduct,
	ScrollButton,
	MdcTextField,
	MdcSelect,
	MobileNav,
	Form,
	HCaptcha,
} from 'webiq.boilerplate'

import run from 'webiq.boilerplate'

run({
	Carousel,
	Accordion,
	Address,
	Orders,
	ShoppingcartAddressSection,
	ShoppingcartPopup,
	ShoppingcartPopupButton,
	ShoppingcartProduct,
	ScrollButton,
	MdcTextField,
	MdcSelect,
	MobileNav,
	Form,
	HCaptcha,
	Typewriter,
	NewMobileNav,
	DynamicNav,
	Register,
	Recovery,
})
